/** Client-side zip of batch outputs (R2): nothing leaves the browser. */
export interface ZipEntry { name: string; blob: Blob; }

export async function zipEntries(entries: ZipEntry[], onProgress?: (done: number, total: number) => void): Promise<Blob> {
    const JSZip = (await import('jszip')).default;
    const zip = new JSZip();
    const used = new Set<string>();
    entries.forEach((e, i) => {
        // keep names unique inside the archive without renaming the first occurrence
        let name = e.name, n = 1;
        while (used.has(name)) { name = e.name.replace(/(\.[^.]+)?$/, m => `-${++n}${m}`); }
        used.add(name);
        zip.file(name, e.blob, { binary: true });
        onProgress?.(i + 1, entries.length);
    });
    return zip.generateAsync({ type: 'blob', compression: 'STORE' }); // images are already compressed
}
